import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';

export default function ForgotPasswordEmailForm({ setPage }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`https://posservice.revampapps.com/ResendOtp?Mail=${encodeURIComponent(email)}`);
      const data = await response.json();
      const result = data?.ResendOtpjs?.Table?.[0];

      if (result?.Status === 'Success') {
        // Go to email verification with reset mode
        setPage({ name: 'forgot', email });  // This sends the real entered email
      } else {
        setError(result?.Message || 'Failed to send OTP. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto max-w-md text-center py-10 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-lg">
        <Mail className="text-teal-500 h-12 w-12 mx-auto mb-4" />
        <h2 className="text-xl font-bold mb-2 text-gray-800">Reset Your Password</h2>
        <p className="text-sm text-gray-600 mb-6">Enter your email to receive an OTP.</p>

        {error && <p className="text-red-600 bg-red-100 p-2 rounded mb-3">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <Mail className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="w-full px-3 py-3 pl-12 border border-gray-300 rounded-lg shadow-sm focus:ring-teal-500 focus:border-teal-500"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center items-center gap-2 bg-teal-600 text-white font-bold py-3 rounded-lg hover:bg-teal-700 transition disabled:opacity-50"
          >
            {loading ? 'Sending OTP...' : 'Continue'}
            <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
